import RailsNestedForm from "@stimulus-components/rails-nested-form"

export default class extends RailsNestedForm {
  static values = {
    max: { type: Number, default: 3 }
  }

  connect() {
    if (this.lineCount() === 0) {
      super.add({ preventDefault() {} })
    }
  }

  add(event) {
    if (this.lineCount() >= this.maxValue) return
    super.add(event)
  }

  ensureMinimumLines(minimum = 2) {
    while (this.lineCount() < minimum && this.lineCount() < this.maxValue) {
      super.add({ preventDefault() {} })
    }
  }

  reset() {
    this.element.querySelectorAll(".mixed-payment-line").forEach((el) => el.remove())
  }

  lineCount() {
    return this.element.querySelectorAll(".mixed-payment-line").length
  }
}
